<template>
  <div class='change_div'>
    <a-form :form='form' layout='vertical'>
      <a-row :gutter='20'>
        <a-col :span='8'>
          <a-form-item :label="$t('customer.customerDetail.changeCustomerRelations.nowRelation')">
            <pt-select :disabled='true' v-model='customer.relations'
                       :placeholder="$t('customer.customerModal.relationsTip')">
              <a-select-option v-for='(nature,index) in relationsSelects' :key='index' :value='nature.wordKey'>
                {{ nature.wordValue }}
              </a-select-option>
            </pt-select>
          </a-form-item>
        </a-col>
        <a-col :span='8'>
          <a-form-item class='required' :label="$t('customer.customerDetail.changeCustomerRelations.changeRelation')">
            <pt-select v-decorator="['relations',{rules:[
                {required: true,message: $t('customer.customerModal.relationsTip'),},
                ]}]" @change='selectChange' :placeholder="$t('customer.customerModal.relationsTip')">
              <a-select-option v-for='(nature,index) in relationsSelects'
                               :disabled='nature.wordKey == customer.relations' :key='index' :value='nature.wordKey'>
                {{ nature.wordValue }}
              </a-select-option>
            </pt-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <a-form-item class='required' :label="$t('customer.customerDetail.changeCustomerRelations.changeReason')">
            <a-textarea  :auto-size="{ minRows: 4, maxRows: 10 }" v-decorator="['reason',{rules:[
                {required: true,message: $t('customer.customerDetail.changeCustomerRelations.reason'),},
                ]}]" :placeholder="$t('customer.customerDetail.changeCustomerRelations.reason')">
            </a-textarea>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { getDatadictChildsByPath } from '@/api/sys/datadict'

export default {
  name: 'changeRelation',
  props: {
    customer: {
      type: Object,
      required: true,
      default: {}
    },
    value: {
      type: String
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      newRelation: '',
      relationsSelects: []
    }
  },
  mounted() {
    this.getRelationsSelects()
  },
  methods: {
    getRelationsSelects() {
      getDatadictChildsByPath('system.business_key.relation').then(res => {
        this.relationsSelects = res.data
      })
    },
    selectChange(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.form.validateFieldsAndScroll((err, values) => {
          console.log("values",values)
          if (!err) {
            this.$emit('input', values)
            resolve(values)
          } else {
            this.$message.warn('请正确输入表单')
            reject()
          }
        })
      })
    }
  }
}
</script>

<style scoped lang='less'>
.change_div {
  background: rgba(248, 249, 251, 0.62);
  border-radius: 4px;
  padding: 30px 20px;
}
</style>